export default {
  'meta': {
    'langName': 'ITALIAN',
    'lang': 'Italiano'
  },
  'title': 'RICHIAMO PRODOTTO CANESTRO DA BASKET B900 BOX NBA TARMAK',
  'description': 'Salve,\n\nGrazie per aver acquistato il canestro da basket Tarmak B900 BOX NBA.\n\nNell\'ambito del nostro impegno costante per la qualità e la sicurezza dei nostri prodotti, le squadre di basket DECATHLON hanno identificato un rischio di caduta verticale del palo se la maniglia di regolazione dell\'altezza viene rimossa e il prodotto viene maneggiato o utilizzato.\n\nLa invitiamo a rispondere alle seguenti domande in modo da poterle fornire una soluzione per garantire la sicurezza del suo prodotto.\n\nCi scusiamo per l\'inconveniente e la ringraziamo per aver scelto il nostro prodotto.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Innanzitutto, può confermare il suo indirizzo email e il suo paese di residenza?'
  },
  'fields': {
    'country': 'Paese',
    'address': 'Indirizzo email',
    'email': 'Indirizzo email',
    'phonePrefix': 'Prefisso',
    'phone': 'Numero di telefono',
    'validations': {
      'phoneOrEmail': 'Si prega di fornire almeno un indirizzo e-mail o un numero di telefono',
      'email': 'Si prega di fornire un indirizzo e-mail valido',
      'phone': 'Si prega di fornire un numero di telefono valido'
    },
    'firstName': 'Cognomne',
    'lastName': 'Nome',
    'deliveryAddress': 'Indirizzo per la consegna del pacco',
    'additionalAddress': 'Dettagli aggiuntivi per l\'indirizzo di consegna',
    'city': 'Città',
    'zip': 'CAP',
    'choose': 'Seleziona',
    'required': 'Questo campo è obbligatorio'
  },
  'ownerCheck': {
    'title': 'Possiede ancora uno o più canestri da basket B900 BOX NBA?'
  },
  'yes': 'SI',
  'no': 'NO',
  'ownerChanged': {
    'title': 'Ha i contatti dell\'attuale proprietario del canestro?',
    'confirmation': 'Sig./Sig.ra\n\nGrazie per la sua partecipazione a questo processo di qualità.\n\nCi scusiamo per ogni eventuale disagio e la ringraziamo per la fiducia.\n\nDECATHLON'
  },
  'recall': {
    'title': 'La preghiamo di comunicarci il numero di canestri da basket in base al tipo di manovella installata.',
    'descriptionRed': 'Canestro da basket con manovella di regolazione rossa rimovibile',
    'descriptionBlack': 'Canestro da basket con manovella di regolazione nera fissa',
    'quantity': 'Quantità',
    'notConcerned': 'Sig./Sig.ra\n\nGrazie per la sua partecipazione a questa iniziativa di qualità.\n\nNon si preoccupi: il suo canestro da basket Tarmak B900 BOX NBA non è interessato dal richiamo. Può essere utilizzato in tutta sicurezza.\n\nCi scusiamo per il disagio e vi ringraziamo per la fiducia.\n\nDECATHLON',
    'concernedProductQuantity': 'Numero di prodotti non conformi:',
    'concernedProductLabel': 'Prodotto non conforme: ',
    'confirmation': 'Grazie per aver compilato questo modulo. La sua richiesta è stata registrata.\n\nLe invieremo il numero di tracciamento per la consegna del suo kit il prima possibile.\n\nBuona giornata.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Riparazione',
    'description': 'Abbiamo rilevato il rischio di caduta verticale del palo se questa maniglia viene rimossa e il prodotto viene maneggiato o utilizzato su alcuni canestri da basket TARMAK B900 BOX NBA, rif. 4239136.\nA seguito della sua risposta, il suo prodotto sembra essere interessato da questo rischio.\n\nLe chiediamo pertanto di non utilizzarlo più e ci offriamo di assisterla nella sostituzione di questa maniglia in modo da poter utilizzare il suo prodotto in sicurezza.\nLe assicuriamo che questa riparazione non richiede alcuna competenza specifica; tutto è chiaramente descritto nel video esplicativo e nelle istruzioni riportate di seguito:',
    'videoLink': 'Link al video',
    'docLink': 'Link istruzioni',
    'callToAction': 'Clicchi qui per ricevere gratuitamente il kit di riparazione',
    'warranty': 'L\'intero processo sarà coperto dalla nostra garanzia di 5 anni'
  },
  'repairRequest': {
    'title': 'Inserisca le seguenti informazioni per ricevere il kit gratuito all\'indirizzo da lei scelto:'
  },
  'form': {
    'submit': 'Successivo'
  },
  'status': 'Translation validated by COUNTRY'
} as const
